export const headers = [
  'id',
  'Project Number',
  'Operation',
  'Name',
  'Division',
  'Progress in time',
  'Latest disbursement made',
  'Amount disbursed',
  'Undisbursed',
  'Performance',
];

export const selectedKeys = [
  'id',
  'code',
  'loanNumber',
  'name',
  'division_code',
  'temporaryAdvance_temporaryAdvanceMade',
  'financialInformation_lastDisbursementInDays',
  'financialInformation_percentRealizedDisbursement',
  'financialInformation_pendingDisbursementAmount',
  'performanceClassification',
];

export const LIMIT_SELECTED_PROJECTS = 10;